import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { referredList } from "../../../../store/actions/referralAction";
import { Dropdown } from "antd";
import { MaskEmail, MaskPhoneNumber } from "../../../../utils/helper";
import TableWrapper from "../../../../components/Tables";
import Pagination from "../../../../components/Pagination";
import { dateFormat } from "../../../../utils/helper";
import axios from "axios";
import { FilterOutlined, DownOutlined, CalendarOutlined, RetweetOutlined, ClockCircleOutlined } from '@ant-design/icons';

const ReferralsIndexDetail = () => {
  const [search, setsearch] = useState("");
  const [updateFilter, setUpdateFilter] = useState("latest")
  const [dateFilter, setDateFilter] = useState("latest")
  const [statusFilter, setStatusFilter] = useState()
  let dispatch = useDispatch();

  const { id } = useParams();

  const dataLogin = useSelector((state) => state.login);
  let { userInfo } = dataLogin;

  useEffect(() => {
    if(id){
        dispatch(referredList(id, 1, search, updateFilter, dateFilter, statusFilter));
    }
  }, [dispatch, id, search, updateFilter, dateFilter, statusFilter]);

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name === "Super Admin") return;
    if (!userInfo.permission.includes("referrals-read")) window.location.href = process.env.REACT_APP_LINK_REDIRECT + "403";
  }, [userInfo]);

  const dataReferralList = useSelector((state) => state.referralList);
  const { referral, listsReferral } = dataReferralList;

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(referredList(id, 1, search, updateFilter, dateFilter, statusFilter));
  };

  const handleResetFilter = () => {
    setStatusFilter(null)
    setDateFilter("latest")
    setUpdateFilter("latest")
  }

  const updateFilterList = ["latest", "oldest"]
  const updateItems = updateFilterList.map((e) => ({
    key: e,
    label: (
      <div onClick={() => setUpdateFilter(e)}>
        {e}
      </div>
    ),
  }));

  const dateFilterList = ["latest", "oldest"]
  const dateItems = dateFilterList.map((e) => ({
    key: e,
    label: (
      <div onClick={() => setDateFilter(e)}>
        {e}
      </div>
    ),
  }));

  const statusFilterList = ["Concierge", "In Progress", "Bank Progress", "Offering Letter", "Ditolak", "Akad"]
  const statusItems = statusFilterList.map((e) => ({
    key: e,
    label: (
      <div onClick={() => setStatusFilter(e)}>
        {e}
      </div>
    ),
  }));

  const tableHead = [
    { name: "No" },
    { name: "Name" },
    { name: "Phone Number" },
    { name: "Email" },
    { name: "Registration" },
    { name: "Last Update" },
    { name: "Status" },
  ];

  const tableBody = [
    { scope: "row" },
    { render: (item) => item.name },
    { render: (item) => <MaskPhoneNumber item={item} /> },
    { render: (item) => <MaskEmail item={item} /> },
    { render: (item) => dateFormat(item.registration)},
    { render: (item) => dateFormat(item.updated_at)},
    { render: (item) => "-"},
   
  ];

  const handleExportToExcel = async () => {
    try {
      const response = await axios.get(`referral/referred/${id}/export-to-excel`, {
        responseType: 'blob',
      });
    
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Referred By ${referral?.referrer_name}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Export failed:", error);
    }    
  }

  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Referred By {referral?.referrer_name}</h3>
        </div>
      </div>
      <div className="clearfix"></div>
      <br />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12 overflow-hidden">
          <div className="x_panel">
            <div className="x_title">
              <div className="row">
                <div className="col-sm-12 d-flex justify-content-end mb-2"><button type="button" class="btn btn-success px-5 btn-sm" onClick={handleExportToExcel}>Export</button></div>
                <div className="col-sm-9 col-xs-12 d-flex justify-content-center flex-wrap">
                  <div className="col-md-11 col-sm-12 d-flex justify-content-center flex-wrap">
                    <Dropdown 
                      menu={{ items: updateItems}} 
                      trigger={['click']} 
                      placement="bottomLeft"
                      value={updateFilter}
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <ClockCircleOutlined className="text-dark"/>
                        <span>{updateFilter} Update</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>

                    <Dropdown 
                      menu={{ items: dateItems}} 
                      trigger={['click']} 
                      placement="bottomLeft"
                      value={dateFilter}
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <CalendarOutlined className="text-dark"/>
                        <span>{dateFilter} Date</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>

                    <Dropdown 
                      menu={{ items: statusItems }} 
                      trigger={['click']} 
                      placement="bottomLeft"
                    >
                      <button 
                        type="button" 
                        style={{ width: "200px", height: "30px" }} 
                        className="btn btn-outline-info btn-sm rounded-pill px-2 text-dark d-flex justify-content-between align-items-center"
                      >
                        <FilterOutlined className="text-dark"/>
                        <span>{statusFilter ?? "All Status"}</span>
                        <DownOutlined style={{ fontSize: '10px' }}/>
                      </button>
                    </Dropdown>
                  </div>
                  
                  <div className="col-md-1 col-sm-12 d-flex justify-content-center">
                    <button 
                      type="button" 
                      style={{ height: "30px" }} 
                      className="btn btn-outline-info btn-sm rounded-pill px-3 text-dark d-flex justify-content-between align-items-center"
                      onClick={handleResetFilter}
                    >
                      <RetweetOutlined className="text-dark"/>
                    </button>
                  </div>
                </div>
                <div className="col-sm-3 col-xs-12 form-group has-feedback">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search By Name"
                    style={{ float: "right", width: "100%", textOverflow: "ellipsis", paddingRight: "40px" }}
                    onChange={(e) => setsearch(e.target.value)}
                  />
                  <button
                    className="fa fa-search form-control-feedback right btn btn-link h-auto"
                    style={{
                      height: "100%",
                      margin: "auto",
                      textDecoration: "none",
                    }}
                    aria-hidden="true"
                    onClick={(e) => handleSearch(e)}
                  ></button>
                </div>
              </div>
              <div className="clearfix"></div>
            </div>

            <div className="x_content overflow-auto">
              <TableWrapper 
                datas={listsReferral}
                tableHead={tableHead}
                tableBody={tableBody}
              />
              <Pagination
                datas={referral}
                listsData={referredList}
                search={search}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralsIndexDetail;
